import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/pix-web/pix-web/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Card = makeShortcode("Card");
const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Card color="white" mdxType="Card">
  <h2 className="card-title">Conoce los recursos que ofrece PiX</h2>
  <p>
    Herramientas pensadas para grupos de trabajo versátiles, que busquen encontrar la herramienta ideal para sus procesos creativos.
  </p>
    </Card>
    <Card color="orange" name="toolkit" img={`pix-card-toolkit.png`} mdxType="Card">
  <h4>Recursos</h4>
  <h2 className="card-title">Toolkit PiX</h2>
  <p>
    Recursos imprimibles para realizar partituras de interacción en formato físico.  Una herramienta ideal para trabajar con un gran y diverso equipo de colaboradores.
  </p>
  <Button type="dark" size="lg" to="https://docs.google.com/uc?export=download&id=1QRMGfkzzcp8Ugoawgri7qq7F_gCspS1t" mdxType="Button">Descargar</Button>
    </Card>
    <Card color="purple" name="illustrator" img={`pix-card-illustrator.svg`} mdxType="Card">
  <h4>Recursos</h4>
  <h2 className="card-title">Adobe Illustrator</h2>
  <p>
    Plantillas y Stencils de partituras de interacción y pixogramas. Ideal para trabajar desde el ordenador y presentar en diferentes formatos como png, jpg, svg. 
  </p>
  <Button type="dark" size="lg" to="#" mdxType="Button">Descargar</Button>
    </Card>
    <Card color="turquoise" name="miro" img={`pix-card-miro.svg`} mdxType="Card">
  <h4>Recursos</h4>
  <h2 className="card-title">Miro</h2>
  <p>
    Miro es una pizarra en línea para colaboración visual en equipo. Contamos con una plantilla pública para hacer un trabajo más dinámico y con mayores libertades.
  </p>
  <Button type="dark" size="lg" to="https://miro.com/miroverse/pix-collab/" mdxType="Button">Ir a Miro</Button>
    </Card>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      